var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "DWSInscan"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "is-full-screen": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('legend', [_vm._v("Falcon DWS Inscan")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Mchine List")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-plug'></i>"
    }
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.machineId),
      expression: "machineId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('MachineId')
    },
    attrs: {
      "name": "MachineId",
      "placeholder": "Select Machine",
      "id": "MachineId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.machineId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Machine Id")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XBSM1"
    }
  }, [_vm._v("XBSM1")])])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MachineId')),
      expression: "errors.has('MachineId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MachineId')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Location")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationName),
      expression: "locationName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Location')
    },
    attrs: {
      "name": "Location",
      "id": "BoudRate"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.locationName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SURAT"
    }
  }, [_vm._v("SURAT")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Location')),
      expression: "errors.has('Location')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Location')))])], 1)], 1)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Weight Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weighttype),
      expression: "weighttype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('WeightType')
    },
    attrs: {
      "name": "WeightType",
      "id": "WeightType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.weighttype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Weight Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FB"
    }
  }, [_vm._v("Falcon-Box")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FP"
    }
  }, [_vm._v("Falcon-Polybags")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('WeightType')),
      expression: "errors.has('WeightType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('WeightType')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Length (cm)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.length),
      expression: "length"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Length')
    },
    attrs: {
      "type": "number",
      "placeholder": "Enter Length",
      "name": "Length",
      "id": "Length",
      "min": "0",
      "disabled": _vm.disabledLength == 1 ? true : false
    },
    domProps: {
      "value": (_vm.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.length = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Length')),
      expression: "errors.has('Length')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Length')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Breadth (cm)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-h'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.breadth),
      expression: "breadth"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Breadth')
    },
    attrs: {
      "type": "number",
      "placeholder": "Enter breadth",
      "name": "Breadth",
      "id": "Breadth",
      "min": "0",
      "disabled": _vm.disabledBreadth == 1 ? true : false
    },
    domProps: {
      "value": (_vm.breadth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.breadth = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Breadth')),
      expression: "errors.has('Breadth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Breadth')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Height (cm)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-v'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.height),
      expression: "height"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Height')
    },
    attrs: {
      "type": "number",
      "placeholder": "Enter Height",
      "name": "Height",
      "id": "Height",
      "min": "0",
      "disabled": _vm.disabledHeight == 1 ? true : false
    },
    domProps: {
      "value": (_vm.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.height = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Height')),
      expression: "errors.has('Height')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Height')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Physical Weight (kg)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physicalweight),
      expression: "physicalweight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('PhysicalWeight')
    },
    attrs: {
      "type": "number",
      "placeholder": "Enter Physical Weight",
      "name": "PhysicalWeight",
      "id": "PhysicalWeight",
      "min": "0",
      "disabled": _vm.disabledPhysicalWeight == 1 ? true : false
    },
    domProps: {
      "value": (_vm.physicalweight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.physicalweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PhysicalWeight')),
      expression: "errors.has('PhysicalWeight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('PhysicalWeight')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-secondary",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-truck'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentid),
      expression: "shipmentid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ShipmentID')
    },
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipment ID",
      "name": "ShipmentID",
      "id": "ShipmentID",
      "autocomplete": "off",
      "maxlength": "20",
      "min": "0"
    },
    domProps: {
      "value": (_vm.shipmentid)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShipmentID')),
      expression: "errors.has('ShipmentID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShipmentID')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmwt),
      expression: "confirmwt"
    }],
    staticClass: "col-md-5 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em",
      "padding-top": "36px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConfirmPhysicalWeight),
      expression: "ConfirmPhysicalWeight"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ConfirmPhysicalWeight",
      "value": "ConfirmPhysicalWeight"
    },
    domProps: {
      "checked": Array.isArray(_vm.ConfirmPhysicalWeight) ? _vm._i(_vm.ConfirmPhysicalWeight, "ConfirmPhysicalWeight") > -1 : (_vm.ConfirmPhysicalWeight)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ConfirmPhysicalWeight,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "ConfirmPhysicalWeight",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ConfirmPhysicalWeight = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ConfirmPhysicalWeight = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ConfirmPhysicalWeight = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "ConfirmPhysicalWeight"
    }
  }, [_vm._v("Confirm Physical Weight")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmvolwt),
      expression: "confirmvolwt"
    }],
    staticClass: "col-md-6 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em",
      "padding-top": "36px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConfirmVolumetricWeight),
      expression: "ConfirmVolumetricWeight"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ConfirmVolumetricWeight",
      "value": "ConfirmVolumetricWeight"
    },
    domProps: {
      "checked": Array.isArray(_vm.ConfirmVolumetricWeight) ? _vm._i(_vm.ConfirmVolumetricWeight, "ConfirmVolumetricWeight") > -1 : (_vm.ConfirmVolumetricWeight)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ConfirmVolumetricWeight,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "ConfirmVolumetricWeight",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ConfirmVolumetricWeight = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ConfirmVolumetricWeight = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ConfirmVolumetricWeight = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "ConfirmVolumetricWeight"
    }
  }, [_vm._v("Confirm Volumetric Weight")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.calculateWeight
    }
  }, [_vm._v("Inscan")]), _vm._v("  \n                          "), _c('button', {
    staticClass: "common-danger",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.cancelID
    }
  }, [_vm._v("Cancel")])])], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.fullSuccessMessage) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', {
    staticStyle: {
      "text-align": "left !IMPORTANT",
      "font-size": "32px"
    }
  }, [(_vm.mpsType) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" " + _vm._s(_vm.mpsType))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("MOT : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.MOT))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Shipment Type : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ShipmentType))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Shipping ID : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayShipmentid))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Destination :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.Destination))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Process Code :"), _c('span', {
    staticStyle: {
      "color": "#4306b9"
    }
  }, [_vm._v(" " + _vm._s(_vm.ProcessCode))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Zone Name :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ZoneName))])])])])])]) : _vm._e()])])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7004656f","hasScoped":true}!./src/views/components/DWSInscanNew/DWSInscanNew.component.html
// module id = 1415
// module chunks = 2